<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-con">
            <div class="modal-txt">
              <div class="txt-ttl">
                {{ $t('modal.update.title') }}
              </div>
              <div class="txt-con">
                <p
                  v-if="!updateInfo.isForce"
                  v-html="$t('modal.update.desc')"
                ></p>
                <p v-else v-html="$t('modal.update.desc_force')"></p>
              </div>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button
                class="btn bo yd-cta yd-cta--secondary"
                @click="dismiss"
                v-if="!updateInfo.isForce"
              >
                {{ $t('modal.update.later') }}
              </button>
              <button class="btn yd-cta yd-cta--primary" @click="update">
                {{ $t('modal.update.update') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import DeviceManager from '@/common/utils/DeviceManager';
import Util from '@/common/utils/Util';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';

import { close } from '@/common/utils/ControlModal';
const { nativeLink } = Util;
const { commit, getters, dispatch } = useStore();
const updateInfo = computed(() => getters['user/getUpdateInfo']);

const dismiss = () => {
  close(DeviceManager.actions.UPDATE);
  DeviceManager.reduce();
};

const update = () => {
  const { deviceType } = updateInfo.value;
  const { APP_STORE, PLAY_STORE } = CODE_ENV_LIST;
  let url = PLAY_STORE;
  if (deviceType === 'IOS') url = APP_STORE;
  nativeLink(url);
  dismiss();
};
</script>

<style scoped></style>
/* *Created on 2023-11-01 *ProjectName user */
